import { useState } from "react";
import { KeyRound } from "lucide-react";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { api, errMsg } from "@/lib/api";

export function TempPassword({ user, url, method = "put", testid }) {
  const [open, setOpen] = useState(false);
  const [pw, setPw] = useState("");
  const save = async (e) => {
    e.preventDefault();
    try {
      await api[method](url, { password: pw });
      toast.success(`New temporary password set for ${user.email}. They'll choose their own at next sign-in.`);
      setPw(""); setOpen(false);
    } catch (err) { toast.error(errMsg(err)); }
  };
  if (!open) return <button type="button" onClick={() => setOpen(true)} className="p-2 text-slate-400 hover:text-slate-900" title="Set a new temporary password" data-testid={`${testid}-open`}><KeyRound className="w-4 h-4" /></button>;
  return (
    <form onSubmit={save} className="flex items-center gap-2 w-full sm:w-auto" data-testid={`${testid}-form`}>
      <Input autoFocus required minLength={8} value={pw} onChange={(e) => setPw(e.target.value)} placeholder="New temporary password (8+)" className="h-9 flex-1 min-w-0 sm:w-56" data-testid={`${testid}-input`} />
      <button type="submit" className="h-9 px-3 rounded-lg bg-slate-900 text-white text-xs font-semibold" data-testid={`${testid}-save`}>Set</button>
      <button type="button" onClick={() => { setOpen(false); setPw(""); }} className="h-9 px-2 text-xs text-slate-500" data-testid={`${testid}-cancel`}>Cancel</button>
    </form>
  );
}
